module.exports = __webpack_public_path__ + "info-v1-2226ccec.svg";